import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_spread_props } from "@swc/helpers/_/_object_spread_props";
import { _ as _object_without_properties } from "@swc/helpers/_/_object_without_properties";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { factory, Flex, Group, useProps, useStyles } from '@coveord/plasma-mantine';
import { Children } from 'react';
import classes from './TopBar.module.css';
import { TopBarAction } from './TopBarAction.js';
import { TopBarProvider } from './TopBarContext.js';
import { TopBarSelect } from './TopBarSelect.js';
var defaultProps = {};
export var TopBar = factory(function(_props, _ref) {
    var _useProps = useProps('TopBar', defaultProps, _props), allChildren = _useProps.children, classNames = _useProps.classNames, styles = _useProps.styles, vars = _useProps.vars, others = _object_without_properties(_useProps, [
        "children",
        "classNames",
        "styles",
        "vars"
    ]);
    var getStyles = useStyles({
        name: 'TopBar',
        classes: classes,
        vars: vars,
        classNames: classNames,
        props: _props,
        styles: styles
    });
    var childrenArray = Children.toArray(allChildren);
    var rightSection = childrenArray.find(function(child) {
        return child.type === TopBarRightSection;
    });
    var children = childrenArray.filter(function(child) {
        return child.type !== TopBarRightSection;
    });
    return /*#__PURE__*/ _jsx(TopBarProvider, {
        value: {
            getStyles: getStyles
        },
        children: /*#__PURE__*/ _jsxs(Group, _object_spread_props(_object_spread({
            flex: 1,
            wrap: "nowrap",
            justify: "space-between"
        }, others, getStyles('root')), {
            children: [
                /*#__PURE__*/ _jsx(Flex, {
                    wrap: "nowrap",
                    gap: {
                        base: 'sm',
                        md: 'xl'
                    },
                    children: children
                }),
                rightSection
            ]
        }))
    });
});
var TopBarRightSection = function TopBarRightSection(param) {
    var children = param.children;
    return /*#__PURE__*/ _jsx(Group, {
        wrap: "nowrap",
        gap: "xs",
        children: children
    });
};
TopBarRightSection.displayName = 'TopBar.Right';
TopBar.Select = TopBarSelect;
TopBar.Action = TopBarAction;
TopBar.Right = TopBarRightSection;
TopBar.displayName = 'TopBar';

//# sourceMappingURL=TopBar.js.map